export function getYoutubeEmbedUrl(url) {
	if (!url) return null;
	const patterns = [
		/youtube\.com\/watch\?v=([\w-]{11})/,
		/youtu\.be\/([\w-]{11})/,
		/youtube\.com\/embed\/([\w-]{11})/,
		/youtube\.com\/shorts\/([\w-]{11})/
	];
	for (let i = 0; i < patterns.length; i++) {
		const match = url.match(patterns[i]);
		if (match) {
			return `https://www.youtube.com/embed/${match[1]}`;
		}
	}
	return null;
}

export function getVideoLinkInfo(url) {
	if (!url) return null;
	const youtube = getYoutubeEmbedUrl(url);
	if (youtube) {
		return { kind: 'youtube', embedUrl: youtube };
	}
	const drive = url.match(/drive\.google\.com\/file\/d\/([\w-]+)/);
	if (drive) {
		return { kind: 'drive', embedUrl: `https://drive.google.com/file/d/${drive[1]}/preview` };
	}
	if (/^https?:\/\/\S+\.mp4(\?\S*)?$/i.test(url)) {
		return { kind: 'mp4', embedUrl: url };
	}
	if (/^https?:\/\/\S+$/i.test(url)) {
		return { kind: 'link', embedUrl: url };
	}
	return null;
}

export function buildAnnouncementFormData({ id, title, content, priority, audienceType, clients, users, publishDate, action, files, keepAttachments, youtubeLinks }) {
	const formdata = new FormData();
	if (id) formdata.append('id', id);
	formdata.append('title', title);
	formdata.append('content', content || '');
	formdata.append('priority', priority);
	formdata.append('audience_type', audienceType);
	formdata.append('clients', JSON.stringify(audienceType === 'targeted' ? (clients || []) : []));
	formdata.append('users', JSON.stringify(users || []));
	formdata.append('publish_date', publishDate || '');
	formdata.append('action', action);
	formdata.append('file', JSON.stringify(files || []));
	formdata.append('keep_attachment', JSON.stringify(keepAttachments || []));
	formdata.append('youtube', JSON.stringify(youtubeLinks || []));
	return formdata;
}

export const MAX_FILE_BYTES = 52428800;
export const MAX_ATTACHMENTS = 10;

const CLIENT_DISPLAY_MAP = {
	dermacool: 'DERMACOL'
};

export function getClientDisplayName(clientCompany) {
	if (!clientCompany) return '';
	if (Object.prototype.hasOwnProperty.call(CLIENT_DISPLAY_MAP, clientCompany)) {
		return CLIENT_DISPLAY_MAP[clientCompany];
	}
	return String(clientCompany).toUpperCase();
}

export function filterAttachmentFiles(files, acceptTypes, currentCount) {
	const result = { accepted: [], oversize: false, overflow: false, badType: false };
	let slots = MAX_ATTACHMENTS - currentCount;
	for (let i = 0; i < files.length; i++) {
		const file = files[i];
		if (acceptTypes.indexOf(file.type) === -1) {
			result.badType = true;
			continue;
		}
		if (file.size > MAX_FILE_BYTES) {
			result.oversize = true;
			continue;
		}
		if (slots <= 0) {
			result.overflow = true;
			continue;
		}
		result.accepted.push(file);
		slots--;
	}
	return result;
}
